export default function initializeHeader() {
    setHeaderPosition();
    window.addEventListener('scroll', () => {
        setHeaderPosition();
    }, false);


}

function setHeaderPosition() {

    const header = document.querySelector('.header');
    const topBar = document.querySelector('.top-bar');

    let lastScrollTop = 0;

    if (document.body.dataset.scroll_script === 'true') {
        document.body.dataset.scroll_script = 'false';
        return;
    }

    const topBarHeight = topBar?.offsetHeight || 0;

    let currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (currentScrollTop > topBarHeight + 2) {
        header.style.top = 0;
        header.classList.add('header--scrolled');
    }
    if(currentScrollTop <= topBarHeight + 2) {
        header.style.top = (topBarHeight - currentScrollTop) + 'px';
        header.classList.remove('header--scrolled');
    }
    lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
}